import { useEffect, useState } from "react";
import { BGM_CATALOG, stopAllCatalogBgm } from "../../audio/bgm/bgmCatalog.js";

export function BgmCatalogSection() {
  const [playingId, setPlayingId] = useState<string | null>(null);

  useEffect(() => () => stopAllCatalogBgm(), []);

  const toggle = (id: string) => {
    const track = BGM_CATALOG.find((item) => item.id === id);
    if (!track) return;
    if (playingId === id) {
      track.stop();
      setPlayingId(null);
      return;
    }
    stopAllCatalogBgm();
    void track.start().then((started) => setPlayingId(started ? id : null));
  };

  return (
    <section className="sound-catalog-bgms" aria-label="BGM一覧">
      {BGM_CATALOG.map((track) => {
        const playing = playingId === track.id;
        return (
          <article className="sound-catalog-bgm" key={track.id}>
            <div>
              <p>BGM</p>
              <h2>{track.name}</h2>
              <p>{track.description}</p>
              <span>{playing ? "再生中" : "停止中"}</span>
            </div>
            <button
              type="button"
              onClick={() => toggle(track.id)}
              aria-label={playing ? `${track.name}BGMを停止` : `${track.name}BGMを再生`}
            >
              {playing ? "停止" : "再生"}
            </button>
          </article>
        );
      })}
    </section>
  );
}
